/**
 * The full-screen layer the survey screens render into.
 *
 * Not the shell's page-content slot: a guest opens the survey from a link
 * after departure, usually logged out, and the shell then shows the auth
 * layout with no page content at all. A layer of its own on <body> looks the
 * same in both modes and leaves the shell untouched underneath — closing the
 * survey simply uncovers whatever was there.
 */
const OVERLAY_ID = "survey-overlay";

export function openOverlay()
{
    let el = document.getElementById( OVERLAY_ID );
    if ( !el )
    {
        el = document.createElement( "div" );
        el.id = OVERLAY_ID;
        el.className = "survey";
        el.setAttribute( "role", "dialog" );
        el.setAttribute( "aria-modal", "true" );
        document.body.appendChild( el );
    }
    // The page underneath must not scroll along with the survey on iOS.
    document.documentElement.classList.add( "survey-open" );
    return el;
}

export function closeOverlay()
{
    const el = document.getElementById( OVERLAY_ID );
    if ( el )
    {
        el.remove();
    }
    document.documentElement.classList.remove( "survey-open" );
}

/** Where "back to the app" leads: home for a signed-in guest, the login otherwise. */
export function appHomeRoute( app )
{
    return app.user ? "/" : "/login";
}
